module.exports = __webpack_public_path__ + "img/new.6ebfd6dc.png";